import { FC } from 'react';
import cls from 'classnames';
import ExclamationMark from 'icon/exclamationmark_triangle_fill.svg';
import { IIllegalInfo } from 'shared/models';

import './style.scss';

interface IWarningLabelProps {
  illegalInfo?: IIllegalInfo;
}

export const WarningLabel: FC<IWarningLabelProps> = (props) => {
  const { illegalInfo } = props;

  if (!illegalInfo) {
    return null;
  }

  return (
    <div className={cls('warning-label')}>
      <p>
        <i className="warning-icon">
          <ExclamationMark />
        </i>
        {illegalInfo.warningLabel}
      </p>
    </div>
  );
};
